import {
  type UpdateProjectConfigTaxExemptionRequest,
  useUpdateProjectConfigTaxExemptionMutation,
} from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useUpdateProjectConfigTaxExemption = () => {
  const [trigger, result] = useUpdateProjectConfigTaxExemptionMutation();
  // TODO: dangerous unmemoized curry
  const curriedTrigger = useCallback(
    (taxExemption: UpdateProjectConfigTaxExemptionRequest['taxExemption']) =>
      trigger(taxExemption, SYNC_STRATEGIES.CORE_ORDER),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
